export enum MessengerProviderId {
  Bale = 1,
  PishgamRayan = 2,
}
